import styled from "styled-components";

export const ContainerDropdown = styled.div``;

export const ContainerCheckbox = styled.div`
  margin-top: 24px;
  margin-bottom: 16px;
  display: flex;
`;

export const DadosPlanilha = styled.div`
  padding: 8px 16px;
  border-radius: 5px;
  margin-bottom: 16px;
  background-color: ${({ theme }) => theme.colors.neutral.neutral10};
`;

export const DadosPlanilhaInfo = styled.div`
  font-size: 15px;
`;

export const DadosPlanilhaTitulo = styled.div`
  font-weight: 600;
  font-size: 17px;
`;

